module.exports = __webpack_public_path__ + "img/1.92995a00.jpg";